import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const STORAGE_KEY = "maktranCookieConsent";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(STORAGE_KEY);
    if (!consent) {
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const respond = (value) => {
    localStorage.setItem(STORAGE_KEY, value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 60 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-md z-[60]"
          data-testid="cookie-banner"
        >
          <div className="bg-slate-800/95 backdrop-blur-md border border-slate-700 rounded-xl p-5 shadow-2xl">
            <div className="flex items-start gap-3 mb-4">
              <Cookie className="h-6 w-6 text-blue-400 flex-shrink-0 mt-0.5" />
              <div>
                <h4 className="font-semibold text-white mb-1">We value your privacy</h4>
                <p className="text-sm text-slate-300 leading-relaxed">
                  We use essential cookies to make our site work and to understand how visitors use it. See our{" "}
                  <Link to="/privacy" className="text-blue-400 hover:text-blue-300 underline underline-offset-2">
                    Privacy Policy
                  </Link>
                  .
                </p>
              </div>
            </div>
            <div className="flex gap-3">
              <button
                onClick={() => respond("accepted")}
                data-testid="cookie-accept-button"
                className="flex-1 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white px-4 py-2.5 rounded-lg text-sm font-semibold transition-all duration-300"
              >
                Accept
              </button>
              <button
                onClick={() => respond("declined")}
                data-testid="cookie-decline-button"
                className="flex-1 border border-slate-600 text-slate-300 hover:bg-slate-700 px-4 py-2.5 rounded-lg text-sm font-semibold transition-all duration-300"
              >
                Decline
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
